import * as React from 'react';
import { IconProps } from '../../dto/Interfaces/IIconProps';

const AirBnB: React.FC<IconProps> = ({ color, size, style }) => {
  return (
    <svg style={style} xmlns="http://www.w3.org/2000/svg" width={size ?? '21'} height={size ?? '21'} fill="none" viewBox="0 0 21 21" data-testid="airbnb-icon">
      <g clipPath="url(#clip0Airbnb)">
        <path
          fill={color ?? '#fff'}
          d="M11.306 15.229c-1.127-1.414-1.79-2.654-2.011-3.714-.219-.856-.133-1.54.242-2.055.397-.592.99-.88 1.767-.88.778 0 1.37.288 1.767.885.373.51.466 1.196.24 2.055-.243 1.083-.905 2.32-2.011 3.715l.005-.006zm8.001.95c-.155 1.039-.861 1.9-1.834 2.319-1.876.816-3.736-.486-5.326-2.253 2.63-3.293 3.117-5.858 1.987-7.515-.662-.95-1.61-1.413-2.829-1.413-2.453 0-3.801 2.076-3.27 4.486.306 1.304 1.125 2.786 2.43 4.443-.817.904-1.593 1.547-2.276 1.944-.532.287-1.039.464-1.524.507-2.233.332-3.983-1.832-3.188-4.066.111-.288.33-.816.705-1.635l.021-.044c1.22-2.648 2.702-5.657 4.405-8.996l.043-.11.484-.93c.376-.685.53-.992 1.127-1.37.287-.174.641-.26 1.039-.26.795 0 1.413.464 1.68.837.132.2.288.466.485.796l.466.906.067.133c1.701 3.337 3.183 6.34 4.398 8.994l.022.021.446 1.018.263.637a3.03 3.03 0 01.178 1.549l.001.002zm1.016-1.991c-.155-.487-.42-1.06-.751-1.745v-.024A292.393 292.393 0 0015.15 3.38l-.094-.134C14.07 1.218 13.36 0 11.304 0 9.273 0 8.41 1.412 7.527 3.25l-.068.132c-1.39 2.697-2.85 5.702-4.42 9.04v.043l-.465 1.017c-.175.42-.263.639-.288.707C1.161 17.282 3.481 20 6.288 20c.024 0 .11 0 .22-.023h.31c1.46-.177 2.962-1.105 4.486-2.764 1.525 1.657 3.03 2.587 4.485 2.764h.31c.111.023.2.023.223.023 2.807.002 5.126-2.718 4-5.812z"
        />
      </g>
      <defs>
        <clipPath id="clip0Airbnb">
          <path fill={color ?? '#fff'} d="M0 0H20V20H0z" transform="translate(.996 .4)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default AirBnB;
